const o = / [a-zA-Z].+?="(.*?)"/g, r = / [a-zA-Z].+?='(.*?)'/g;
function c(e, t) {
  return e.replace(t, l(t));
}
function a(e) {
  const t = new RegExp("{{[^}]+}}", "g");
  return e ? e.replace(t, function(n) {
    return window.encodeURIComponent(n).replace("fallback%3A", "fallback:").replace(/'/g, "%27");
  }) : "";
}
function l(e) {
  const t = /%7B%7B.+%7D%7D/g;
  let n;
  for (; n = t.exec(e); )
    try {
      e = e.replace(n[0], window.decodeURIComponent(n[0]));
    } catch {
      console.log("received an invalid URI component ", n[0]);
    }
  return e;
}
function i(e) {
  return e.replace(/<([^>]*)>/g, function(t, n) {
    return t.replace(n, a(n));
  });
}
function u(e) {
  return e.replace(o, c).replace(r, c);
}
export {
  l as decodeAttributes,
  u as decodeUriAttributes,
  a as encodeAttributes,
  i as encodeUriAttributes
};
